/**
* DevExpress HTML/JS Reporting (chart\widgets\_chartDependencyEditor.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { extend } from '@devexpress/analytics-core/analytics-internal-native';
import { createViewModelGenerator } from '@devexpress/analytics-core/analytics-serializer-native';
import { Editor } from '@devexpress/analytics-core/analytics-widgets';
import * as ko from 'knockout';
export class ChartDependencyEditor extends Editor {
    constructor(info, level, parentDisabled, textToSearch) {
        super(info, level, parentDisabled, textToSearch);
    }
    getViewModel() {
        return createViewModelGenerator(super.createViewModel())
            .generateProperty('getDependencyOptions', (templateOptions, propertyName, depPropertyName) => this.getDependencyOptions(templateOptions, propertyName, depPropertyName))
            .getViewModel();
    }
    getDependencyOptions(templateOptions, propertyName, depPropertyName) {
        if (!this.bindableOptions) {
            const debObj = {};
            this.depProperty = ko.computed(() => {
                const model = this._get('_model');
                return model && model[depPropertyName]();
            });
            this._disposables.push(this.depProperty);
            debObj[propertyName] = this.depProperty;
            this.bindableOptions = extend({}, this.getOptions(templateOptions), debObj);
        }
        return this.bindableOptions;
    }
}
